import Vuex, {mapState} from 'vuex';

import { Dictionary } from "./modules/dictionary";
import { LoadingElement } from "./modules/loadingElement";
import { CurrentUser } from "./modules/currentUser";
import { HideComponent } from './modules/hideComponent';
import { StepTwo } from './modules/pricelistsStepTwo';
import { GlueClinics } from  './modules/glueClinics'

export const Store = new Vuex.Store({
    modules: {
        currentUser: CurrentUser,
        dictionary: Dictionary,
        loadingElement: LoadingElement,
        hideComponent: HideComponent,
        stepTwo: StepTwo,
        glueClinics: GlueClinics,
    }
});
